var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 742,
    height: 742,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "101.743%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    stopOpacity: 0.64,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.8%",
    y: "-28.8%",
    width: "157.7%",
    height: "157.7%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.192 1530.192c0 143.594 116.406 260 260 260s260-116.406 260-260c-.167-143.525-116.475-259.834-260-260-143.594 0-260 116.406-260 260Z",
    filter: "url(#b)",
    transform: "translate(-60 -1153)",
    fill: "url(#a)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsIllustration);
export default __webpack_public_path__ + "static/media/cards-illustration.37113ac2d6f6109407b745a0b3b79355.svg";
export { ForwardRef as ReactComponent };